import { render, staticRenderFns } from "./TabNoteNonConfermate.vue?vue&type=template&id=2b0c6b72&"
import script from "./TabNoteNonConfermate.vue?vue&type=script&lang=js&"
export * from "./TabNoteNonConfermate.vue?vue&type=script&lang=js&"
import style0 from "./TabNoteNonConfermate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabNoteNonConfermate.vue
// module id = 910
// module chunks = 0